import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";

export const ResumePDFCustom = ({
  heading,
  custom,
  themeColor,
  showBulletPoints,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  showBulletPoints: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <ResumePDFSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription 
          items={descriptions} 
          enableHighlight={enableHighlight}
          enableMistakeHighlight={enableMistakeHighlight}
          section="custom"
          itemIndex={null}
        />
      </View>
    </ResumePDFSection>
  );
};
